import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const CouponComponent = ({isActive, customerId, defaultProductImage, couponList}) => {
    const { t } = useTranslation();

    const [showModal, setShowModal] = useState(false);
    const [showInformation, setShowInformation] = useState(false);
    const [currentValue, setCurrentValue] = useState({});

    const statusClasses = {
        "Redeemed": "bg-green-normal",
        "Expired": "bg-red-normal",
        "Assigned": "bg-blue-normal",
        "Ready to Redeem": "bg-sky-normal",
    };
    const handleShowInformation = (e, value) => {
        e.preventDefault();
        setCurrentValue(value);
        setShowInformation(!showInformation);
    };

    return (
        <div className="p-2 sm:p-0 bg-white sm:bg-transparent border border-white sm:border-none rounded-lg sm:rounded-none space-y-2 sm:space-y-0 shadow-around sm:shadow-none">
            {(couponList.length > 0) ?
                <>
                    <div className="flex sm:hidden justify-between items-center sm:space-x-2 rounded-lg">
                        <h1 className="sm:text-lg font-semibold sm:font-bold capitalize">{ t('all coupons')}</h1>
                        {/* <div className="flex items-center justify-end space-x-2">
                            <div className="relative inline-block">
                                <button onClick={(e) => handleShowStatus(e)} type="button" className="bg-background-normal text-gray-dark w-full justify-between font-normal py-2.5 px-4 rounded-md inline-flex items-center text-base space-x-3">
                                    <span className={(status) ? "text-black capitalize " : "text-gray-dark capitalize " + " mr-1"}>{status ? status : ''}</span>
                                    <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                </button>
                                {
                                    showStatus
                                    ? 
                                        <ul className="z-20 py-3 bg-white top-12 absolute right-0 border border-white shadow-md rounded-[10px] w-max text-left">
                                            <li key="0" onClick={(e) => handleStatus((e), "all")}  className="bg-white hover:bg-action-hover py-1 px-4 block whitespace-no-wrap cursor-pointer capitalize text-sm">all</li>
                                            <li key="1" onClick={(e) => handleStatus((e), "redeemed")}  className="bg-white hover:bg-action-hover py-1 px-4 block whitespace-no-wrap cursor-pointer capitalize text-sm">redeemed</li>
                                            <li key="2" onClick={(e) => handleStatus((e), "expired")}  className="bg-white hover:bg-action-hover py-1 px-4 block whitespace-no-wrap cursor-pointer capitalize text-sm">expired</li>
                                            <li key="3" onClick={(e) => handleStatus((e), "valid")}  className="bg-white hover:bg-action-hover py-1 px-4 block whitespace-no-wrap cursor-pointer capitalize text-sm">valid</li>
                                        </ul>                            
                                    : null
                                }
                            </div>
                            <div className="relative"> 
                                <div className="flex w-fit items-center cursor-pointer bg-black-300 rounded-lg py-2 px-3 sm:px-4" onClick={(e) => handleShowSort(e)}>
                                    <img className="w-6 h-6" src="../../../assets/icons/table/sort.svg" alt="sort" />
                                    <div className="hidden sm:block ml-2 text-blue-normal font-medium text-xl capitalize">{ t('sort')}</div>
                                </div>
                                {
                                    showSort 
                                    ?
                                        <ul className="z-20 py-3 bg-white top-12 absolute right-0 border border-white shadow-md rounded-[10px] w-max text-left">
                                            {sortTypesList.map((value, index) => (
                                                <li key={index} onClick={(e) => handleSortType((e), value)} className={(sortName === value.name ? "bg-action-hover" : "bg-white") + " hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-sm"}>{ t(value.name)}</li>
                                            ))}
                                        </ul>
                                    : 
                                    <div className="p-4 text-center font-bold text-xs sm:text-xl rounded-lg capitalize bg-white block sm:hidden">
                                        { t('no records available')}
                                    </div>
                                }
                            </div>
                        </div> */}
                    </div>
                    <div className="block sm:hidden my-2 sm:my-4 border-t border-background-normal"></div>
                </>
            :  
                <div className="p-2 text-center font-bold text-xs sm:text-xl rounded-lg capitalize bg-white block sm:hidden">
                    { t('no records available')}
                </div>
            }
            <div className="grid lg:grid-cols-2 xl:grid-cols-3 sm:gap-4 bg-transparent rrounded-none p-0">
                <NavLink to={(isActive ? `/profiles/create-coupon/${customerId}` : null)} className={(isActive ? "cursor-pointer" : "cursor-not-allowed") + " rounded-xl border-gray-normal border border-dashed hidden sm:flex flex-col justify-center items-center h-24"}>
                    <div className="flex items-center space-x-2">
                        <img className="w-8 h-8" src="../../assets/icons/profile/plus.svg" alt="plus" />
                        <div className="font-medium capitalize">{ t("add new coupon")}</div>
                    </div>
                </NavLink>
                {(couponList.length > 0) ?
                    couponList.map((coupon, index) => (
                        <div key={`coupon${index}`}>
                            <div onClick={(e) => setShowModal(!showModal)} className="rounded-xl bg-white sm:px-2 py-1 sm:py-2 flex justify-between space-x-2 w-full shadow-around">
                                <div className="relative w-20 sm:w-28">
                                    <img className="w-14 h-14 sm:w-20 sm:h-20 rounded-lg border border-background-normal" src={defaultProductImage} alt="product-img" />
                                    <div onClick={(e) => handleShowInformation(e, coupon)} className="absolute right-0 bottom-0 bg-white rounded-md p-1 shadow-md cursor-pointer">
                                        <img src={`../../assets/icons/profile/information.svg`} alt="information" />
                                    </div>
                                </div>
                                <div className="flex flex-col justify-evenly w-full">
                                    <h1 className="font-semibold text-xs sm:text-sm capitalize">{coupon.BatchName}</h1>
                                    <div className="flex justify-between space-x-1 items-center w-full capitalize text-[10px] text-light-700">
                                        {coupon.Description}
                                    </div>
                                    <div className="flex justify-between items-center text-[10px]">
                                        <div className="capitalize">
                                            <div className="capitalize text-light-700">{ t('expiry')}: <span className="font-medium text-black">{coupon.Expiry}</span></div>
                                        </div>
                                        <div className={`${statusClasses[coupon.CouponStatus] || ""} capitalize text-white px-2 py-1 rounded-md`}>
                                            {coupon.CouponStatus}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="my-1 border-t border-dashed border-background-normal block sm:hidden"></div>
                        </div>
                    ))
                : null}
            </div>
            <div className="fixed bottom-2 sm:hidden w-screen left-0 px-4">
                <NavLink to={(isActive ? `/profiles/create-coupon/${customerId}` : null)} className={(isActive ? "cursor-pointer" : "cursor-not-allowed")}>
                    <div className="rounded-lg  p-2 text-white bg-blue-normal font-medium text-center capitalize">
                        + { t("add new coupon")}
                    </div>
                </NavLink>
            </div>
            {showInformation && (
                <div className="fixed z-50 overflow-y-auto top-0 w-full left-0 h-full">
                    <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0 h-full">
                        <div className="fixed inset-0 transition-opacity">
                            <div className="absolute inset-0 bg-gray-900 opacity-75" />
                        </div>
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                        <div className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-sm w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                            <div className="bg-white p-4 space-y-3">
                                <div className="flex justify-between items-center">
                                    <div className="font-semibold text-sm sm:text-lg capitalize">{currentValue.BatchName}</div>
                                    <div className="cursor-pointer" onClick={(e) => setShowInformation(!showInformation)}>
                                        <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                                    </div>
                                </div>
                                <div className="rounded-lg py-2 px-2 border border-background-normal text-black">
                                    <h1 className="capitalize font-semibold">{ t('description')}</h1>
                                    <p className="text-light-700 text-sm">{currentValue.Description}</p>
                                </div>
                                <div className="text-right">
                                    <button type="button"  onClick={(e) => setShowInformation(!showInformation)} className="uppercase border border-background-normal text-light-700 rounded-lg py-1 px-4">{ t('ok')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default CouponComponent;